/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { Heading } from '@msdyn365-commerce-modules/utilities';

import { IConnellyBackgroundVideoData } from './connelly-background-video.data';
import { IConnellyBackgroundVideoProps } from './connelly-background-video.props.autogenerated';

export interface IConnellyBackgroundVideoViewProps extends IConnellyBackgroundVideoProps<IConnellyBackgroundVideoData> {
    title?: React.ReactNode;
    videoId?: string;
    overlay?: string;
    className?: string;
    

}

/**
 *
 * ConnellyBackgroundVideo component
 * @extends {React.PureComponent<IConnellyBackgroundVideoProps<IConnellyBackgroundVideoData>>}
 */
class ConnellyBackgroundVideo extends React.PureComponent<IConnellyBackgroundVideoProps<IConnellyBackgroundVideoData>> {
    public render(): JSX.Element | null {

        const { heading } = this.props.config;

        const headingTitle = heading && heading.text && <Heading className='absolute-content-block__title' headingTag={heading.tag} text={heading.text} />;

        const { config } = this.props;

        const VideoId = config.videoId ? config.videoId : '';
        const Overlay = config.overlay ? config.overlay : '';
        const ClassName = config.className ? config.className : '';
        

        const VideoProps = {
            ...this.props,
            title: headingTitle,
            videoId: VideoId,
            overlay: Overlay,
            className: ClassName
        };

        return this.props.renderView(VideoProps) as React.ReactElement;
    }
}

export default ConnellyBackgroundVideo;
